import cx from 'classnames';
import './Badge.css';

/**
 * QHS Badge v2
 * ------------
 * Two strict palettes:
 *   Clinical Status (semantic, color = meaning):
 *     'critical' | 'high' | 'moderate' | 'normal' | 'pending' | 'inactive'
 *   Category Tags (neutral, color only differentiates):
 *     'slate' | 'sage' | 'indigo' | 'stone' | 'wine' | 'graphite'
 *
 *   <Badge tone="critical">Critical</Badge>
 *   <Badge tone="sage" size="sm">ISP</Badge>
 *   <Badge tone="critical" dot>Critical</Badge>  // opt-in dot
 *
 * `dot` is opt-in. Mixed-palette columns (e.g. an account-tags
 * column containing both category labels and the clinical
 * "Inactive" status) read as random when only some rows carry the
 * dot — so we leave the marker off by default and let the caller
 * turn it on for surfaces that exclusively show one palette.
 */
const Badge = ({ tone = 'slate', size = 'md', dot = false, className, children, ...rest }) => {
  return (
    <span
      className={cx(
        'qhs-badge',
        `qhs-badge--${tone}`,
        `qhs-badge--${size}`,
        dot && 'qhs-badge--dot',
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
};

export default Badge;
